import { render, staticRenderFns } from "./PokerHand.vue?vue&type=template&id=32b26919&scoped=true&"
import script from "./PokerHand.vue?vue&type=script&lang=js&"
export * from "./PokerHand.vue?vue&type=script&lang=js&"
import style0 from "./PokerHand.vue?vue&type=style&index=0&id=32b26919&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b26919",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VCard,VCardText,VMain})
